export default __webpack_public_path__ + "static/businessproduct-d86e64054bee3c2666f056406e6e1bca.png";